import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';

interface Section {
  title: string;
  points?: string[];
  intro?: string;
  company?: string;
  address?: string[];
  email?: string;
}

const TermsOfService = () => {
  const { t } = useTranslation();

  const renderSection = (sectionKey: string) => {
    const section = t(`terms.sections.${sectionKey}`, { returnObjects: true }) as Section;
    
    if (sectionKey === 'contact') {
      return (
        <div key={sectionKey} className="mb-8">
          <h2 className="text-2xl font-bold mb-4">{section.title}</h2>
          <p className="mb-4">{section.intro}</p>
          <div className="space-y-2">
            <div dangerouslySetInnerHTML={{ __html: section.company || '' }} />
            {section.address?.map((line: string, index: number) => (
              <p key={index}>{line}</p>
            ))}
            <p>{section.email}</p>
          </div>
        </div>
      );
    }

    return (
      <div key={sectionKey} className="mb-8">
        <h2 className="text-2xl font-bold mb-4">{section.title}</h2>
        <div className="space-y-4">
          {section.points?.map((point: string, index: number) => (
            <p key={index} className="text-gray-700" dangerouslySetInnerHTML={{ __html: point }} />
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Helmet>
        <title>{t('terms.title')} | SafeTripVax</title>
        <meta name="description" content={t('terms.title')} />
      </Helmet>

      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8">
          <h1 className="text-3xl font-bold mb-8 text-center">{t('terms.title')}</h1>
          
          {['general', 'services', 'responsibility', 'copyright', 'contact', 'final'].map(renderSection)}
        </div>
      </div>
    </div>
  );
};

export default TermsOfService; 